import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  position: relative;
  flex-shrink: 0;

  .disabled-hover-target {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    &.submenu-active {
      width: calc(100% - 38px);
    }
  }

  .invisible-padding {
    position: absolute;
    padding: 50px 80px;
    opacity: 0;
  }

  .disabled-hover-target .hover-tip {
    width: 200px;
  }

  .hover-tip a {
    padding: 0;
    text-decoration: underline var(--context-menu-text);
  }
`;
